export const name = 'gzL10nLoader';

export default function gzL10nLoader($log, $q, $translate, rnHttp, rnRegistry) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  return loadAllCatalogs;

  /////////////////

  /**
   * Loads all specified catalogs
   * @example
   * loadAllCatalogs({
   * catalogServices: {
   *    'admin.common': 'portal_service'
   *  },
   * });
   * @param options.catalogServices mapping of catalogs to Genesis services
   *  where these catalogs can be retrieved.  Catalog URLs will be resolved using the rhino registry.
   * @returns {Promise.<Object>} a promise to an object with localized strings.
   */
  function loadAllCatalogs(options) {
    let catalogPromises = [];

    // Reduce locales like 'en-UK' to language codes understood by Genesis services.
    let lang = options.key.split('-')[0];

    if(!options.catalogServices) {
      options.catalogServices = {};
    }

    ensureDefaultCatalogs(options.catalogServices);

    _.forIn(options.catalogServices, function(service, catId) {
      catalogPromises.push(loadCatalogFromService(service, catId, lang));
    });

    return resolveCatalogPromises(options.key, catalogPromises);
  }

  function resolveCatalogPromises(langKey, promises) {
    // Inspired by the source for $q.all() but to not stop at first rejection.
    // https://github.com/angular/angular.js/blob/6838c979451c109d959a15035177ccee715ccf19/src/ng/q.js#L538
    let deferred = $q.defer();
    let allCatalogs = {};

    let remainingPromises = promises.length;
    _.forEach(promises, function resolved(promise) {
      promise.then(function(catalog) {
        // Append to all catalogs object
        _.assign(allCatalogs, catalog);
      }).finally(function promiseFinally() {
        // See if there are any promises left.
        // If not, resolve if we have any catalog data or reject otherwise.
        remainingPromises--;
        if(remainingPromises <= 0) {
          if(!_.isEmpty(allCatalogs)) {
            deferred.resolve(allCatalogs);
          } else {
            deferred.reject(langKey);
          }
        }
      });
    });

    return deferred.promise;
  }

  function ensureDefaultCatalogs(catalogServices) {
    if(!catalogServices['uxf.uxf']) {
      catalogServices['uxf.uxf'] = 'portal_service';
    }
  }

  function loadCatalogFromService(service, catId, lang) {
    let catalogId = getCatalogId(catId);

    return rnRegistry.getRegistry()
      .then(registry => {
        let printosVersion = registry.keys.printosVersion;
        let opts = {
          cache: true
        };
        if (printosVersion) {
          // Cache catalogs by PrintOS deployment version
          opts.params = {
            v: printosVersion,
          };
          opts.headers = {
            // Overwrite default parameters
            'If-Modified-Since': undefined,
            'Cache-Control': undefined,
          };
        }
        return rnHttp.get(service, `i18n/${catalogId}/${lang}`, opts);
      })
      .then(response => {
        let messages = response.data.messages;
        let catalog = {};
        _.forEach(messages, function(message) {
          catalog[catId + '.' + message.msgId] = message.msgText;
        });
        return catalog;
      })
      .catch(res => {
        $log.warn(`Failed to get localization catalog '${catId}' from ${service}`);
        $q.reject(res);
      });
  }

  function getCatalogId(catId) {
    let catRefArray = catId.split('.');
    let catalogId = catRefArray[0];
    if (catRefArray.length > 1) {
      // Support old 'appId.catalogId' form
      catalogId = catRefArray[1];
    }

    return catalogId;
  }
}
